import React from 'react';
import PropTypes from 'prop-types';
import ResponsivePicture from '../../Elements/ResponsivePicture/ResponsivePicture';
import { breakpoints } from '../imageDefaults';

import './PhotoCard.scss';

const PhotoCard = ({ previewImage }) => (
    <div className="component--share-components-UnifiedPostCard-PhotoCard">
        <div className="photoCardContainer">
            {previewImage?.src && (
                <ResponsivePicture
                    cloudinaryID={previewImage.src}
                    breakpoints={breakpoints}
                    alt={previewImage.alt}
                />
            )}
        </div>
    </div>
);

export default PhotoCard;

PhotoCard.propTypes = {
    previewImage: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
};

PhotoCard.defaultProps = {
    previewImage: null,
};
